import { computed, onBeforeMount, ref } from 'vue'

import { useInitializeAd } from '../advertisement/composables/use-initilize-ad'
import { appendMoltenBundleScript } from '../advertisement/providers/molten-bundle-script'
import { useAdaStore } from '../stores/ada'
import { useConfigStore } from '../stores/config'
import { useUrlHelper } from './url-helper'

export const registerSlots = ref<string[]>([])
export const autonativeSlots: string[] = ['superbanner_1', 'skyscraper_1', 'wallpaper_1', 'mobile_1']

interface QueryParams {
  ada?: string,
  ftz?: string
}

export const useAdProvider = (brand: string) => {
  const { getQueryParams } = useUrlHelper()
  const configStore = useConfigStore()
  const adaStore = useAdaStore()

  const rsConfig = ref(configStore.rsConfig)

  useInitializeAd()

  const previewBundle = ref(false)

  onBeforeMount(() => {
    const isForceTestZone = ref(adaStore.isForceTestZone)

    const queryParams = getQueryParams() as QueryParams
    const forceTestZone = queryParams.ftz

    if (forceTestZone) {
      adaStore.setTestZone(forceTestZone)
      // check if we can do this
      // adaStore.forcePreviewBundle()
      previewBundle.value = true
    } else {
      adaStore.checkForceTestZoneCookie()
    }
    if (queryParams.ada === '1') {
      previewBundle.value = true
    } else if (isForceTestZone.value) {
      // apply testZone=develop to URL - not loosing existing query params
      const urlParams = new URLSearchParams(window.location.search)
      if (!urlParams.has('testZone')) {
        urlParams.set('testZone', 'develop')
      }
      history.pushState(null, '', `?${urlParams.toString()}`)
    }
  })

  const brandConfig = computed(() => {
    if (typeof window === 'undefined') {
      return { previewBrand: 'default_brand', brandNamespace: 'defaultbrandNamespace' }
    }
    const urlParams = new URLSearchParams(window.location.search)
    const usePreviewNames = urlParams.has('ada') && urlParams.get('ada') === '1'
    const brandMap: Record<string, { previewBrand: string, brandNamespace: string }> = {
      todaysgolfer: { previewBrand: usePreviewNames ? 'todays_golfer' : 'todaysgolfer', brandNamespace: 'todaysgolfer' },
      intouch: { previewBrand: usePreviewNames ? 'intouch_toni' : 'intouch', brandNamespace: 'intouch' },
      cosmopolitan: { previewBrand: usePreviewNames ? 'cosmopolitan_toni' : 'cosmopolitan', brandNamespace: 'cosmopolitan' }
    }
    return brandMap[brand] || { previewBrand: 'default_brand', brandNamespace: 'defaultbrandNamespace' }
  })

  const initAdProvider = () => {
    const { previewBrand } = brandConfig.value
    // Append top script
    appendMoltenBundleScript('top', previewBrand, rsConfig.value.cdnUri, previewBundle.value)

    // Append bottom script
    appendMoltenBundleScript('bottom', previewBrand, rsConfig.value.cdnUri, previewBundle.value)
  }

  return { initAdProvider }
}
